import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieConsent from "./components/feature/CookieConsent";
import GlobalOrganizationSchema from "./components/feature/GlobalOrganizationSchema";
import SiteNavigationSchema from "./components/feature/SiteNavigationSchema";
import ScrollToTop from "./components/feature/ScrollToTop";
import BackToTopButton from "./components/feature/BackToTopButton";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <GlobalOrganizationSchema />
        <SiteNavigationSchema />
        <AppRoutes />
        <CookieConsent />
        <BackToTopButton />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
